

















































































































import Vue from 'vue';
import { ActionsKeys } from '@/store/types';

export default Vue.extend({
  methods: {
    accept() {
      this.$store.dispatch(ActionsKeys.SET_TOS_ACCEPTED);
    },
    refuse() {
      this.$emit('tos-refused');
    },
  },
});
